import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { shape, number, string, arrayOf } from 'prop-types';
import QRCodeIcon from '#component/icon/qrcode-icon';
import { downloadFile } from '#action/download';

/**
 * Renders MUI IconButton with tooltip to download device label.
 * @returns {React.FC}
 */

const DownloadDeviceLabel = ({ device: { title, uid, id } = {} }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleDownloadClick = async event => {
    event.stopPropagation();
    const path = `report/device/${id}/label`;
    const fileName = `Label ${title || uid}.pdf`;

    await dispatch(downloadFile(
      path,
      fileName
    ));
  };

  return (
    <IconButton
      size="small"
      aria-label="Download device label"
      color="inherit"
      onClick={handleDownloadClick}
    >
      <Tooltip title="Download device label">
        <QRCodeIcon style={{ color: theme.palette.grey[600] }} />
      </Tooltip>
    </IconButton>
  );
};

DownloadDeviceLabel.propTypes = {
  device: shape({
    id: number,
    uid: string,
    title: string,
    projects: arrayOf(number)
  })
};

export default DownloadDeviceLabel;
